// ─────────────────────────────────────────────────────────────────────────────
// useUserFilters — owns the search box, the status/role/team filters, and the
// current page. Kept separate from data-fetching so the toolbar/table stay
// presentational (mirrors Nodes' useNodeFilters).
// ─────────────────────────────────────────────────────────────────────────────
import { useEffect, useState } from "react";

export function useUserFilters() {
  const [search,       setSearch]       = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [filterRole,   setFilterRole]   = useState("All");
  const [filterTeam,   setFilterTeam]   = useState("All");
  const [page,         setPage]         = useState(1);

  // Any filter change returns to the first page.
  useEffect(() => { setPage(1); }, [search, filterStatus, filterRole, filterTeam]);

  const hasFilters =
    filterStatus !== "All" || filterRole !== "All" || filterTeam !== "All";

  return {
    search, setSearch,
    filterStatus, setFilterStatus,
    filterRole, setFilterRole,
    filterTeam, setFilterTeam,
    page, setPage, hasFilters,
  };
}
